"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProblemCode = void 0;
var ProblemCode;
(function (ProblemCode) {
    /* WARNING CODES */
    ProblemCode["EnvironmentSiteAssessmentCosts"] = "CL1001";
    ProblemCode["BorrowersChargesExceedOfficersLimit"] = "CL1002";
    ProblemCode["TotalClaimsPayableAmountExceedAutoPayLimits"] = "CL1003";
    ProblemCode["ExcessivePropertyValueDecline"] = "CL1004";
    ProblemCode["PortfolioInsuranceEligibilityReviewRequired"] = "CL1005";
    ProblemCode["PropertyDamagedInsuranceSettlementInvolvedManualReviewRequired"] = "CL1006";
    ProblemCode["PropertyRepairsExceedsLimits"] = "CL1007";
    ProblemCode["PropertyRepairsExceedsPreapprovedLimits"] = "CL1008";
    ProblemCode["MechanicsBuildersLiensConditionalSalesContractsCostsExceed$5000"] = "CL1009";
    ProblemCode["GroundSiteRentExceeds$7200"] = "CL1010";
    ProblemCode["OtherBorrowersCharges999"] = "CL1011";
    ProblemCode["PropertyIncomeClaimed"] = "CL1012";
    ProblemCode["PartialPaymentClaimed"] = "CL1013";
    ProblemCode["OutstandingPrincipalBalance029BorrowerCharge"] = "CL1017";
    ProblemCode["ClaimFilingExtensionObtained"] = "CL1018";
    ProblemCode["PaymentsDeferredAndNotReimbursed"] = "CL1019";
    ProblemCode["ReviewDefaultPrincipalBalance"] = "CL1020";
    /* SUSPENSE CODES */
    ProblemCode["SupplementaryClaimReceivedLessThan$250"] = "02";
    ProblemCode["SupplementaryClaimsDocsNotReceivedTitleJudgmentOrBankrupt"] = "04";
    ProblemCode["AmortizationOfLoanExceeds40Years"] = "05";
    ProblemCode["AdmissibleDateNeedsReview"] = "07";
    ProblemCode["CompleteClaimReceivedDateIsBlank"] = "10";
    ProblemCode["RFFICheckFound"] = "11";
    ProblemCode["GVSPVIIIndicatorFound"] = "17";
    ProblemCode["ITMNotApproved"] = "22";
    ProblemCode["EDDFEMSIIndicatorFound"] = "35";
    ProblemCode["NumberOfChargesClaimedExceedsSystemLimit"] = "98";
    ProblemCode["OtherBorrowerCharges"] = "12";
    ProblemCode["OutstandingPrincipalBalance"] = "29";
    ProblemCode["PropertyDamagedInsuranceSettlementInvolved"] = "34";
    ProblemCode["MultipleReasons"] = "99";
    ProblemCode["NoApprovedAmountBorrowerCharges"] = "08";
    // TODO: remove after DMP has updated their endpoint
    ProblemCode["DeprecatedCompleteClaimReceivedDateIsBlank"] = "CL1029";
})(ProblemCode = exports.ProblemCode || (exports.ProblemCode = {}));
